/* ============================================================
   Custom Modern Theme — micro-interactions
   Back-to-top button, scroll progress bar, button cursor glow,
   and staggered reveal for grid items.
   ============================================================ */
/* ============================================================
   Custom Modern Theme — micro-interactions
   Page loader, back-to-top button, scroll progress bar, button
   cursor glow, and staggered reveal for grid items.
   ============================================================ */

/* Insert loader as early as possible, before DOMContentLoaded */
(function () {
  var loader = document.createElement('div');
  loader.className = 'cm-loader';
  document.documentElement.appendChild(loader);

  function hideLoader() {
    loader.classList.add('cm-loader--hidden');
    window.setTimeout(function () {
      loader.remove();
    }, 700);
  }

  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader);
    // Safety net in case load takes too long
    window.setTimeout(hideLoader, 2500);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  /* Scroll progress bar */
  var progress = document.createElement('div');
  progress.className = 'cm-progress-bar';
  document.body.appendChild(progress);

  function updateProgress() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progress.style.width = pct + '%';
  }

  /* Back to top button */
  var backToTop = document.createElement('button');
  backToTop.className = 'cm-back-to-top';
  backToTop.setAttribute('aria-label', 'Back to top');
  backToTop.innerHTML =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>';
  document.body.appendChild(backToTop);

  backToTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateProgress();
          backToTop.classList.toggle('is-visible', window.scrollY > 480);
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true }
  );
  updateProgress();

  /* Cursor-follow glow on buttons */
  var buttons = document.querySelectorAll('.button');
  buttons.forEach(function (btn) {
    btn.addEventListener('pointermove', function (e) {
      var rect = btn.getBoundingClientRect();
      btn.style.setProperty('--cm-x', ((e.clientX - rect.left) / rect.width) * 100 + '%');
      btn.style.setProperty('--cm-y', ((e.clientY - rect.top) / rect.height) * 100 + '%');
    });
  });

  /* Staggered reveal for card grids that aren't already using scroll-trigger */
  var grids = document.querySelectorAll('.grid:not(.scroll-trigger)');
  if ('IntersectionObserver' in window) {
    var gridObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var items = entry.target.querySelectorAll('.grid__item');
            items.forEach(function (item, i) {
              item.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
              item.classList.add('cm-in-view');
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );
    grids.forEach(function (grid) {
      gridObserver.observe(grid);
    });
  }
});
